// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"_8-z"};